import { render, staticRenderFns } from "./ZArec.vue?vue&type=template&id=b2ac77b2"
import script from "./ZArec.vue?vue&type=script&lang=js"
export * from "./ZArec.vue?vue&type=script&lang=js"
import style0 from "./ZArec.vue?vue&type=style&index=0&id=b2ac77b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports